module.exports = __webpack_public_path__ + "media/application/images/ui/icon-chevron-white-7dc5a2955971a738e9b980c9925b92a0.png";